/**
 * Destroys one per-account PowerSync database instance and forgets it.
 *
 * Extracted from `power-sync-context.tsx` so the destroy path (remove account,
 * real sign-out) can be tested without mounting the provider. The provider owns
 * the maps; this function only receives them.
 */
export interface DestroyableDbInstance {
  db: { disconnectAndClear: () => Promise<void> };
  connector: { clearTokenCache: () => Promise<void> };
}

export async function destroyDbInstance(
  instances: Map<string, DestroyableDbInstance>,
  promises: Map<string, unknown>,
  key: string,
  onError: (err: unknown) => void,
): Promise<void> {
  const instance = instances.get(key);
  instances.delete(key);
  promises.delete(key);
  if (!instance) {
    return;
  }
  try {
    await instance.connector.clearTokenCache();
    await instance.db.disconnectAndClear();
  } catch (err) {
    onError(err);
  }
}
